import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import PrivateRoute from "./PrivateRoute";
import RegisterPage from "../Pages/RegisterPage";
import ResultPage from "../Pages/ResultPage";
import LoginPage from "../Pages/LoginPage";
import ExcelUploadPage from "../Pages/ExcelUploadPage";
import PredictPage from "../Pages/PredictPage";
import HomePage from "../Pages/HomePage";
import UploadModelPage from "../Pages/UploadModelPage";
import AdminRoute from "./AdminRoute";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <HomePage />
                    </PrivateRoute>
                ),
            },
            {
                path: "/form",
                element: (
                    <PrivateRoute>
                        <PredictPage />
                    </PrivateRoute>
                ),
            },
            {
                path: "/form/results",
                element: (
                    <PrivateRoute>
                        <ResultPage />
                    </PrivateRoute>
                ),
            },
            {
                path: "/from-file",
                element: (
                    <PrivateRoute>
                        <ExcelUploadPage />
                    </PrivateRoute>
                ),
            },
            {
                path: "/from-file/results",
                element: (
                    <PrivateRoute>
                        <ResultPage />
                    </PrivateRoute>
                ),
            },
            {
                path: "/upload-model",
                element: (
                    <PrivateRoute>
                        <AdminRoute>
                            <UploadModelPage />
                        </AdminRoute>
                    </PrivateRoute>
                ),
            },
            { path: "login", element: <LoginPage /> },
            { path: "register", element: <RegisterPage /> },
        ],
    },
]);
